/**
 * Pending UI for route transitions, shown by the router's
 * `defaultPendingComponent` when a loader takes longer than
 * `defaultPendingMs` (see router.tsx).
 *
 * Deliberately a thin top bar rather than a skeleton of the page: it replaces
 * the outlet, so a per-page skeleton here would be wrong for whichever page is
 * actually loading, and the surrounding chrome (sidebar, header) stays put.
 */
export function RouteProgress() {
  return (
    <div
      role="status"
      aria-label="Loading"
      className="fixed inset-x-0 top-0 z-50 h-0.5 overflow-hidden bg-transparent"
    >
      <div className="h-full w-full origin-left animate-pulse bg-primary/70" />
    </div>
  )
}
